module.exports = __webpack_public_path__ + "img/logo1.3ca28641.png";